import $ from "jquery";
import { Modal } from "bootstrap";

export const Prop65Modal = () => {
    $(document).ready(() => {
            const prop65Modal = new Modal($("#prop-warning-modal"), {
                keyboard: false,
            });

            $('#prop-65-link').on('click', (e) => {
                e.preventDefault();
                prop65Modal.toggle();
            });
        }
    );
};
